import React from 'react';
import { Outlet, ScrollRestoration } from 'react-router-dom';
import Stack from '@mui/material/Stack/Stack';
import Box from '@mui/material/Box/Box';
import { ImpersonationBanner } from './components/ImpersonationBanner';
import { AppFooter } from './components/AppFooter/AppFooter';
import { CookieBanner } from './components/CookieBanner/CookieBanner';
import { TelemetryTracker } from './components/TelemetryTracker';

export const RootLayout = () => {
    return (
        <>
            <ScrollRestoration />
            <TelemetryTracker />
            <Stack className="App" spacing={1}>
                <ImpersonationBanner />
                <Box sx={{ minHeight: 'calc(100vh - 87px)', position: 'relative' }}>
                    <Outlet />
                </Box>
                <AppFooter />
                <CookieBanner />
            </Stack>
        </>
    );
};
